(function() {
    'use strict';

    angular
        .module('app.directive')
        .directive('taiHeader', taiHeader);

    function taiHeader() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: ControllerController,
            controllerAs: 'vm',
            link: link,
            templateUrl: 'directive/taiHeader.directive.html',
            restrict: 'E',
            scope: {
                showCtms: '@',
                site: '@'
            }
        };
        return directive;

        function link() {}
    }
    /* @ngInject */
    function ControllerController(translateService, $route, modalService, $location,
        sysCode, loginService, headerService, $rootScope, menuService, $filter, trainingInnerService) {
        var vm = this;
        vm.login = login;
        vm.logout = logout;
        vm.redirecter = redirecter;
        vm.choiceLanguage = choiceLanguage;
        vm.touchWithMe = touchWithMe;
        vm.openSetting = openSetting;
        vm.searchClick = searchClick;
        vm.doSearch = doSearch;
        vm.searchChange = searchChange;
        vm.transferurl = transferurl;
        vm.getMenuList = getMenuList;
        vm.getfirstMenuList = getfirstMenuList;
        vm.getsecMenuList = getsecMenuList;
        vm.getthirdMenuList = getthirdMenuList;
        vm.navmenuClick = navmenuClick;
        vm.rootClick = rootClick;
        vm.secmenuOpen = secmenuOpen;
        vm.switchClose = switchClose;
        vm.thirdmenuOpen = thirdmenuOpen;
        vm.languageOpen = languageOpen;
        vm.appVersion = null;

        vm.view = {
            isLogin: !_.isEmpty(sessionStorage.getItem('perSerilNo')) && !sessionStorage.getItem('isForce'),
            showSearchList: true,
            showFastList: true,
            isMobile: sessionStorage.getItem('isMobile')
        };

        onInit();

        function onInit() {

            $('.search-modal-sm').on('show.bs.modal', function() {
                vm.searchClick();
            });

            $('.search-modal-sm').on('hide.bs.modal', function() {

                var $content = $("#navmenu-content");
                if ($content.css('right') !== '0px') {
                    $('section.nav').css("position", "static");
                } else {
                    $('section.nav').css("position", "fixed");
                }
            });

            vm.data = {};
            $rootScope.$on('updateCName', function(e, value) {
                vm.cName = value;
            });
            vm.cName = sessionStorage.getItem('cName');

            translateService.getLanguage().then(function(data) {
                vm.languageItems = data.data;
                return vm.languageItems;
            }).then(function(data) {
                vm.defaultLanguage = translateService.getDefault(data);
                $("body").addClass(vm.defaultLanguage.langCode);
                //console.log(vm.defaultLanguage);

                //console.log('taiHeader_Init-menuItemPath:' + sessionStorage.getItem('menuItemPath'));
                //撈取選單資料
                vm.getMenuList();
            });

            headerService.getFontSize().then(function(data) {
                vm.fontSizes = data.data;
                $rootScope.fontSize = _.filter(vm.fontSizes.fontSizes, {
                    isSelected: true
                })[0].sizeCode + 'px';
            });

            vm.last = { index: 0, $: null };

            switchSearchList('');
        }



        function getMenuList() {
            headerService.getMenuList().then(function(data) {
                vm.data.menuAllList = data.data;
                vm.data.menuAllList.forEach(function(allmenu) {
                    if (sessionStorage.getItem('menuSerilNo') === null || sessionStorage.getItem('menuSerilNo') === '') {
                        sessionStorage.setItem('menuSerilNo', getMenuQueryString());
                    }

                    //console.log('taiHeader_Init-menuSerilNo:' + sessionStorage.getItem('menuSerilNo'));
                    if (allmenu.menuSerilNo === parseInt(sessionStorage.getItem('menuSerilNo')) && !allmenu.hasChild) {
                        allmenu.menuItemStyle = { 'background-color': '#da2128', 'color': '#fff' };
                    } else {
                        allmenu.menuItemStyle = '';
                    }
                });

                sessionStorage.setItem('menuAllList', JSON.stringify(vm.data.menuAllList));
                vm.getfirstMenuList();

            });
        }

        function getfirstMenuList() {
            var menuLists = $filter('filter')(vm.data.menuAllList, {
                parentId: 0,
                level: 1
            });

            vm.firstmenuList = menuLists;
            return vm.firstmenuList;
        }

        function getsecMenuList(menuSerilNo) {
            var menuLists = $filter('filter')(vm.data.menuAllList, {
                parentId: menuSerilNo,
                parentIdLen: String(menuSerilNo).length,
                level: 2
            });

            vm.secmenuList = menuLists;
            return vm.secmenuList;
        }

        function getthirdMenuList(menuSerilNo) {
            var menuLists = $filter('filter')(vm.data.menuAllList, {
                parentId: menuSerilNo,
                parentIdLen: String(menuSerilNo).length,
                level: 3
            });

            vm.thirdmenuList = menuLists;
            return vm.thirdmenuList;
        }

        function navmenuClick() {

            var w = $(window).width();
            var $content = $("#navmenu-content");
            var $blackcover = $(".ui-blackCover");

            $content.animate({ scrollTop: 0 }, 50);
            $("div.menu-content").css("right", -w);

            if ($content.css('right') !== '0px') {
                $content.animate({ right: '0px' }, 300, 'swing');
                if (w < 1000) {
                    $blackcover.css("display", "block");
                    $('section.nav').css("position", "fixed");
                } else {
                    $('section.nav').css("position", "static");
                }
            } else {
                $content.animate({ right: '-' + w + 'px' }, 300, 'swing');
                if (w < 1000) {
                    $blackcover.css("display", "none");
                }

                $('section.nav').css("position", "static");
            }

            //展第二及第三層功能選單資料
            if (sessionStorage.getItem('menuItemPath') !== null && sessionStorage.getItem('menuItemPath') !== '' && sessionStorage.getItem('menuItemPath').split(',').length !== 1) {
                console.log("navmenuClick-menuItemPath:" + sessionStorage.getItem('menuItemPath'));
                //展第二層資料
                //console.log("first = " + sessionStorage.getItem('menuItemPath').split(',')[0]);             
                vm.firstmenuItem = vm.data.menuAllList.filter(function(menuLists) {
                    return (menuLists.menuSerilNo === parseInt(sessionStorage.getItem('menuItemPath').split(',')[0]));
                });
                //console.log(vm.firstmenuItem);
                if (vm.firstmenuItem[0] !== null) {
                    console.log(vm.firstmenuItem[0]);
                    rootClick(vm.firstmenuItem[0], 0, true);
                }

                //展第三層資料
                //console.log("second = " + sessionStorage.getItem('menuItemPath').split(',')[1]);
                if (sessionStorage.getItem('menuItemPath').split(',').length === 3) {
                    vm.secmenuItem = vm.data.menuAllList.filter(function(menuLists) {
                        return (menuLists.menuSerilNo === parseInt(sessionStorage.getItem('menuItemPath').split(',')[1]));
                    });
                    if (vm.secmenuItem[0] !== null) {
                        console.log(vm.secmenuItem[0]);
                        rootClick(vm.secmenuItem[0], 1, true);
                    }
                }
            }

        }

        function secmenuOpen() {
            var $content = $("#secondMenu-content");
            $content.animate({ right: '0px' }, 300, 'swing');
            $("#navmenu-content").animate({ scrollTop: 0 }, 0); //將捲軸置頂
            $("li.level_menu").each(function() {
                $(this).removeClass("open");
            });
        }

        function languageOpen() {
            var $content = $("#Language-content");
            $content.animate({ right: '0px' }, 300, 'swing');
        }

        function switchClose(menuName) {
            var w = $(window).width();
            var $content = $("#" + menuName);
            $content.animate({ right: '-' + w + 'px' }, 300, 'swing');
        }

        function thirdmenuOpen(menuName, index) {
            var $this = $("#" + menuName + "-open");
            var $this_index = index;
            $this.toggleClass("open");
            $this.siblings("li").removeClass("open");
            if ($this.hasClass("open")) {
                var scrollgoto = $this.offset().top + $('#navmenu-content').scrollTop() - 40 - $(window).scrollTop();
                setTimeout(function() { $('#navmenu-content').animate({ scrollTop: scrollgoto }, 500); }, 200);
                //console.log("thirdmenuOpen-scrollgoto:"+scrollgoto);
                vm.last.index = $this_index;
                vm.last.$ = $this;
                if ($this_index) {
                    $(".ul_padding").css("height", scrollgoto);
                } else {
                    $(".ul_padding").css("height", "0px");
                }

            } else {
                $(".ul_padding").css("height", "0px");
            }
        }

        function rootClick(item, index, anchor) {
            //判斷是點選下階圖檔還是選單名稱決定要導頁或顯示下階
            if (anchor) {
                if (parseInt(item.level) === 1) {
                    vm.firstMenuLangName = item.menuLangName;
                    vm.getsecMenuList(item.menuSerilNo);
                    vm.secmenuOpen();
                } else {
                    vm.getthirdMenuList(item.menuSerilNo);

                    setTimeout(function() { vm.thirdmenuOpen(item.menuName, index + 1); }, 50);
                }
            } else if (item.url) {
                if (!item.hasChild) {
                    sessionStorage.setItem('menuSerilNo', '');
                    sessionStorage.setItem('menuItemPath', '');
                    sessionStorage.setItem('menuSerilNo', item.menuSerilNo);
                    sessionStorage.setItem('menuItemPath', item.menuItemPath);
                    vm.navmenuClick();
                    // console.log('current url:', location.href);
                    // console.log('rootClick:', item.url);
                    if (location.href.toLowerCase().indexOf('sessionid') > 0 ||
                        location.href.toLowerCase().indexOf('courseid') > 0) {
                        // console.log("current url:",location.href);
                        // console.log("redirecter url:",url);
                        //2023-07-10 Johnson 資安2023
                        location.href = eval(function (p, a, c, k, e, r) { e = function (c) { return c.toString(a) }; if (!''.replace(/^/, String)) { while (c--) r[e(c)] = k[c] || e(c); k = [function (e) { return r[e] }]; e = function () { return '\\w+' }; c = 1 }; while (c--) if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]); return p }('2.3.4(\'?\').0(/</1,\'&5\').0(/>/1,\'&6\').0(/"/1,\'&7\').0(/\'/1,\'&#8\').0(/[<>!]|(\\(\\))|((9|a|b)\\c*\\(.*\\))/1,\'\')', 13, 13, 'replace|g|location|href|split|lt|gt|quot|x27|for|while|if|s'.split('|'), 0, {}))
                    }
                    menuService.redirectUrl(item);
                }
            }
        }



        function choiceLanguage(item) {
            item.selected = true;
            vm.defaultLanguage = translateService.change(item);
            $(".ui-blackCover").css("display", "none");
            $route.reload();
        }

        function login() {
            //debugger;
            var result = modalService.login();
            result.result.then(function(data) {
                if (data) {
                    // $route.reload();                    
                }
            });
            sessionStorage.setItem('menuSerilNo', '');
            sessionStorage.setItem('menuItemPath', '');
            vm.navmenuClick();
        }

        function redirecter(url) {
            if (location.href.toLowerCase().indexOf('sessionid') > 0 ||
                location.href.toLowerCase().indexOf('courseid') > 0) {
                // console.log("current url:",location.href);
                // console.log("redirecter url:",url);
                //2023-07-10 Johnson 資安2023
                location.href = eval(function (p, a, c, k, e, r) { e = function (c) { return c.toString(a) }; if (!''.replace(/^/, String)) { while (c--) r[e(c)] = k[c] || e(c); k = [function (e) { return r[e] }]; e = function () { return '\\w+' }; c = 1 }; while (c--) if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]); return p }('2.3.4(\'/#\')[0]+\'/#\'+5+\'?6=\'+7.8(\'9\').1(/</g,\'&a\').1(/>/g,\'&b\').1(/"/g,\'&c\').1(/\'/g,\'&#d\').1(/[<>!]|(\\(\\))|((e|f|h)\\i*\\(.*\\))/g,\'\')', 19, 19, '|replace|location|href|split|url|menu|sessionStorage|getItem|menuSerilNo|lt|gt|quot|x27|for|while||if|s'.split('|'), 0, {}))
            }
            $location.path(url);
            //如果正確導向，就不會往下跑了。
            // console.log("page reload");
            $route.reload(); //for SPA
        }

        function logout() {

            loginService.logout().then(function() {
                // 通知 APP 登出成功 
                if (DEVICE_TYPE) {
                    var param = {};
                    var method = "logout";
                    appCallback(method, param);
                }
                sessionStorage.setItem('menuSerilNo', '');
                sessionStorage.setItem('menuItemPath', '');
                removeSsoInfo();
                $location.path('/login').search({});
            });

            $(".ui-blackCover").css("display", "none");
        }

        function touchWithMe() {

            modalService.touchWithMe();

            vm.navmenuClick();
        }

        function openSetting() {

            modalService.setting(vm.fontSizes);

            vm.navmenuClick();
        }

        function searchClick($event) {

            let siteCode = getSiteCode(vm.site);
            headerService.getSearch('', siteCode).then(function(data) {
                vm.data.searchList = data.data;
                switchSearchList('');
            });

            $('section.nav').css("position", "static");
        }

        function specialKeywordVerification(keyWord){
            /*2020-06-11 Johnson
            特殊字元 【\】【/】【<】【>】【'】【"】【(】【)】【%】【.】
            問題單：2020/05/13  2020 APP滲透測試報告
            https://app.asana.com/0/742244134012369/1175524709436847
            */
            keyWord = keyWord.replace(/\\/g,"/");
            var pattern = new RegExp("[/\\/<>'\"()%.]");
            var result = false; 
            for (var i = 0; i < keyWord.length; i++) {
                console.log('for keyWord:'+keyWord.substr(i, 1) +' pattern:'+keyWord.substr(i, 1).replace(pattern, 'false'));
                if (keyWord.substr(i, 1).replace(pattern, 'false') == "false") {result=true; }
            } 
            return result;
        }

        function searchChange() {
            //2020-06-11 Johnson 搜尋欄位有資料才查詢
            if(vm.search != ""){
                //2020-06-11 Johnson 搜尋欄位特殊字元檢核
                var SKV = specialKeywordVerification(vm.search);

                console.log('SKV:'+SKV);

                if(!SKV){
                    let siteCode = getSiteCode(vm.site);
                    headerService.getSearch(vm.search, siteCode).then(function(data) {
                        vm.data.searchList = data.data;
                        switchSearchList(vm.search);
                    });
                }else
                {
                    console.log('specialKeywords:'+$rootScope.translate.specialKeywords);
                    toastr.warning($rootScope.translate.specialKeywords);
                }
            }
        }

        function switchSearchList(keyword) {
            if (keyword) {
                // 有輸入關鍵字，僅顯示查詢清單
                vm.view.showSearchList = true;
                vm.view.showFastList = false;
            } else {
                // 點選放大鏡圖示時(沒有輸入關鍵字)，僅顯示快速選單
                // 但台新外網沒有快速選單，所以不顯示任何資訊
                vm.view.showSearchList = false;
                vm.view.showFastList = false;
            }
        }

        function doSearch(keyWord) {
            if (keyWord) {

                let siteCode = getSiteCode(vm.site);
                vm.view.showSearchList = false;
                $('body').removeClass('modal-open');
                $("body>div.modal-backdrop.fade.in").css('display', 'none');
                $location.path('/header/searchResult/' + keyWord + '/' + siteCode);
                // $location.path('/visualpage/30');
            }
        }

        function getSiteCode() {
            let siteCode = 2;
            if (vm.site === 'tsun') {
                siteCode = 4;
            }
            return siteCode;
        }

        function transferurl(item) {
            $("body>div.modal-backdrop.fade.in").css('display', 'none');
            menuService.redirectUrl(item);
        }
    }

})();